import { FC, useState } from "react";
import close from "assets/images/close.svg";
import Button from "components/particles/primary-button";
import { Container, StyledReactModal, Tbody } from "./style";
import placeHolder from "assets/images/placeholder.jpg";

import unlink from "assets/images/unlink.svg";
import NoDataFound from "components/particles/no-data-found";
import { dispatch } from "store";
import { setModalClosed } from "store/user-slice";
import { useSelector } from "react-redux";
import useCategories from "containers/categories/useHook";
import Swal from "sweetalert2";

interface LinkedIngredientModelProps {
  id: number;
  name?: string;
  data: any[];
  setData: Function;
  onRefresh?: () => void;
}

const DietariesLinkedIngredientModal: FC<LinkedIngredientModelProps> = ({
  id,
  name,
  data,
  setData,
  onRefresh,
}) => {
  const { dietariesLinkedIngredientModalIsOpen, isLoading } = useSelector(
    (state: any) => state.user
  );
  const [dietarySearchData, setDietarySearchData] = useState<any[]>([]);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const { unLinkedDietaryIngredients, searchIngredientsForDietary } =
    useCategories();

  function closeModal() {
    dispatch(setModalClosed("Dietaries Linked Ingredient"));
  }

  const [searchQuery, setSearchQuery] = useState({
    name: "",
  });

  const search = async () => {
    if (searchQuery.name.trim() !== "") {
      setIsSearchActive(true);
      setDietarySearchData([]);
      await searchIngredientsForDietary(
        id,
        searchQuery.name,
        setDietarySearchData
      );
    } else {
      setIsSearchActive(false);
      setDietarySearchData([]);
    }
  };

  const reset = () => {
    setSearchQuery({ name: "" });
    setDietarySearchData([]);
    setIsSearchActive(false);
  };

  const handleUnLinkedIngredient = (ingredientId: number) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Unlink this ingredient from the dietary?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "var(--reset-button)",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, unlink it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await unLinkedDietaryIngredients(ingredientId, data, setData);

          if (isSearchActive) {
            setDietarySearchData((prev) =>
              prev.filter((item) => item.associationId !== ingredientId)
            );
          }

          if (onRefresh) {
            onRefresh();
          }
        } catch (error) {
          console.error("Error unlinking ingredient:", error);
        }
      }
    });
  };

  const columns: any[] = [
    {
      name: "Sr No.",
      class: "th",
    },
    {
      name: "Image",
      class: "th",
    },
    {
      name: "Ingredient Name",
      class: "th",
    },
    {
      name: "Actions",
      class: "th",
    },
  ];

  const displayedData = isSearchActive ? dietarySearchData : data;

  return (
    <StyledReactModal
      isOpen={dietariesLinkedIngredientModalIsOpen}
      onRequestClose={closeModal}
      contentLabel="Linked Dietary Ingredients Modal"
    >
      <Container>
        <div className="close-button" onClick={closeModal}>
          <img src={close} style={{ cursor: "pointer" }} alt="img" />
        </div>
        <div className="popup-title">
          <h1>
            {name
              ? `Linked Ingredients - ${name}`
              : "Linked Dietary Ingredients"}
          </h1>
        </div>
        <div className="search-container">
          <div className="input-fields">
            <input
              type="text"
              placeholder="Search By Name"
              value={searchQuery.name}
              onChange={(e) => {
                setSearchQuery({ ...searchQuery, name: e.target.value });
              }}
            />
          </div>
          <Button title="Search" width="16rem" fill="true" onclick={search} />
          <Button
            title="Reset"
            width="16rem"
            fill="true"
            backgroundcolor="var(--reset-button)"
            onclick={reset}
          />
        </div>
        <div className="inner-container">
          <div className="categories-model-ingredient-container p-custom-scrollbar-8 custom-scrollbar">
            <div className="data-table">
              <table>
                <thead>
                  <tr>
                    {columns.map((column: any, index: number) => (
                      <th key={index} className={column.class}>
                        {column?.name}
                      </th>
                    ))}
                  </tr>
                </thead>
                <Tbody>
                  {isLoading ? (
                    <tr>
                      <td colSpan={columns.length}>
                        <div className="modal-loader">Loading...</div>
                      </td>
                    </tr>
                  ) : displayedData.length > 0 ? (
                    displayedData.map((ingredient: any, index: number) => (
                      <tr key={ingredient?.associationId ?? index}>
                        <td>{index + 1}</td>
                        <td>
                          <img
                            src={
                              ingredient?.image &&
                              !ingredient?.image.includes(
                                `${process.env.REACT_APP_BASE_URL}images/placeholder`
                              )
                                ? ingredient?.image
                                : placeHolder
                            }
                            alt="img"
                            width={30}
                            style={{ borderRadius: "50%" }}
                          />
                        </td>
                        <td>{ingredient?.name}</td>
                        <td className="actions">
                          <button
                            onClick={() =>
                              handleUnLinkedIngredient(
                                ingredient?.associationId
                              )
                            }
                            className="tooltip link-button"
                          >
                            <img src={unlink} alt="img" />
                            <p>Unlink</p>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <NoDataFound isShow={true} />
                  )}
                </Tbody>
              </table>
            </div>
          </div>
        </div>
      </Container>
    </StyledReactModal>
  );
};

export default DietariesLinkedIngredientModal;
